import _defineProperty from "/root/workspace/admin_admin-web_uLO7/node_modules/@babel/runtime/helpers/esm/defineProperty";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/root/workspace/admin_admin-web_uLO7/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";

var _name$filters$compone;

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { postDownloadUserNewUserInfo, postDownloadUserLostUserInfo } from '@/api/bairun/bairunData.js'; //  此处请自行替换地址

import { formatTimeToStr } from '@/utils/date';
import { getStationBaseInfoList } from '@/api/bairun/stationBaseInfo';

var _this;

export default (_name$filters$compone = {
  name: 'LostUsers',
  filters: {
    formatDate: function formatDate(time) {
      if (time != null && time !== '') {
        var date = new Date(time);
        return formatTimeToStr(date, 'yyyy-MM-dd hh:mm:ss');
      } else {
        return '';
      }
    },
    formatBoolean: function formatBoolean(bool) {
      if (bool != null) {
        return bool ? '是' : '否';
      } else {
        return '';
      }
    },
    getStationName: function getStationName(id) {
      for (var i = 0; i < _this.stationOptions.length; i++) {
        if (_this.stationOptions[i].ID === id) {
          return _this.stationOptions[i].stationName;
        }
      }

      return '';
    }
  },
  components: {},
  data: function data() {
    var that = this;
    return {
      stationOptions: [],
      formatDate: {},
      pickerOptionsStart: {
        shortcuts: [{
          text: '今天',
          onClick: function onClick(picker) {
            picker.$emit('pick', new Date());
          }
        }, {
          text: '昨天',
          onClick: function onClick(picker) {
            var date = new Date();
            date.setTime(date.getTime() - 3600 * 1000 * 24);
            picker.$emit('pick', date);
          }
        }, {
          text: '一周前',
          onClick: function onClick(picker) {
            var date = new Date();
            date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', date);
          }
        }, {
          text: '一月前',
          onClick: function onClick(picker) {
            var date = new Date();
            date.setTime(date.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', date);
          }
        }, {
          text: '三月前',
          onClick: function onClick(picker) {
            var date = new Date();
            date.setTime(date.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', date);
          }
        }]
      },
      pickerOptions: {
        disabledDate: function disabledDate(time) {
          var curDate = new Date(that.formatDate.startTime).getTime();
          var three = 92 * 24 * 3600 * 1000;
          var threeMonths = curDate + three;
          return time.getTime() < curDate || time.getTime() > threeMonths;
          ;
        }
      },
      endPickerOptions: {
        disabledDate: function disabledDate(time) {
          var curDate = new Date(that.formatDate.endTime).getTime();
          return time.getTime() < curDate;
        }
      }
    };
  }
}, _defineProperty(_name$filters$compone, "filters", {
  formatDate: function formatDate(time) {
    if (time != null && time !== '') {
      var date = new Date(time);
      return formatTimeToStr(date, 'yyyy-MM-dd hh:mm:ss');
    } else {
      return '';
    }
  }
}), _defineProperty(_name$filters$compone, "beforeCreate", function beforeCreate() {
  _this = this;
}), _defineProperty(_name$filters$compone, "created", function created() {
  var _this2 = this;

  return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
    var stationOptions;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            // 使用keepalive的页面,重新展示不会调用
            console.log('created');
            _context.next = 3;
            return getStationBaseInfoList({
              page: 1,
              pageSize: 999999,
              donNotShowLoading: true
            });

          case 3:
            stationOptions = _context.sent;
            _this2.stationOptions = stationOptions.data.list;

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }))();
}), _defineProperty(_name$filters$compone, "methods", {
  times: function times() {
    return 'test';
  },
  onSubmit: function onSubmit() {
    var _this3 = this;

    var obj = {
      "stationId": this.formatDate.stationId,
      "startTime": formatTimeToStr(this.formatDate.startTime, 'yyyy-MM-dd hh:mm:ss'),
      "endTime": formatTimeToStr(this.formatDate.endTime, 'yyyy-MM-dd hh:mm:ss'),
      "afterTime": formatTimeToStr(this.formatDate.afterTime, 'yyyy-MM-dd hh:mm:ss')
    };
    postDownloadUserLostUserInfo(obj).then(function (res) {
      console.log(res);

      if (res.code === 0) {
        _this3.$message({
          message: res.msg,
          type: 'success'
        });
      }
    }, function (err) {});
  }
}), _name$filters$compone);